/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const updateMyUserProfileBodyAddressAddressLine1Max = 200;

export const updateMyUserProfileBodyAddressAddressLine2Max = 200;

export const updateMyUserProfileBodyAddressPostcodeRegExp = new RegExp('^\\d{4}$');
export const updateMyUserProfileBodyAddressSuburbMax = 100;

export const UpdateMyUserProfileBody = zod.object({
  acceptLatestTerms: zod.boolean().optional(),
  address: zod
    .object({
      addressLine1: zod.string().min(1).max(updateMyUserProfileBodyAddressAddressLine1Max),
      addressLine2: zod.string().max(updateMyUserProfileBodyAddressAddressLine2Max).optional(),
      country: zod.enum(['AU']).optional(),
      postcode: zod.string().regex(updateMyUserProfileBodyAddressPostcodeRegExp),
      state: zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
      suburb: zod.string().min(1).max(updateMyUserProfileBodyAddressSuburbMax),
    })
    .optional()
    .describe(
      'Postal address, replacing the stored one part by part. Street line, suburb, state and postcode are required together; `addressLine2` is optional and `country` defaults to AU. Australian addresses only.',
    ),
  dob: zod.string().optional(),
  email: zod.email().optional(),
  firstName: zod.string().min(1).optional(),
  lastName: zod.string().min(1).optional(),
  phoneNumber: zod.string().min(1).optional(),
  sexAtBirth: zod.string().optional(),
});

export type UpdateMyUserProfileBody = zod.input<typeof UpdateMyUserProfileBody>;
export type UpdateMyUserProfileBodyOutput = zod.output<typeof UpdateMyUserProfileBody>;
